import {
	IFavouriteFilterModel,
	FavouriteFilterGroupModel,
	FavouriteFilterModel,
	FavouriteFilterModelMapper
} from "./../models/favourite-filter/favourite-filter-model";
import { ServicesWrapper } from "./generic.services";
import {
	IFavouriteFilterRequestModel,
} from "../models/favourite-filter/favourite-filter-model";
import { ApiResponse } from "../models/app-configuration";
import moduleConstant from "../common/module-constant";

//#region DEFINE METHODS
export const favouriteFilterServicesMethod = {
	GET_LIST_FAVOURITES: "getListOfFavourites",
	GET_DETAIL_FAVOURITE: "getDetailFavourite",
	ADD_FAVOURITE: "addFavourite",
	UPDATE_FAVOURITE: "updateFavourite",
	DELETE_FAVOURITE: "deleteFavourite",
	UPDATE_DEFAULT_FAVOURITE: "updateDefaultFavourite"
};
//#endregion

//#region  DEFINE URL
export const favouriteFilterServicesUrl = {
	LIST_FAVOURITES: "/users/filters",
	DETAIL_FAVOURITE: "/users/filters/:id",
	ADD_FAVOURITE: "/users/filters-add",
	UPDATE_FAVOURITE: "/users/filters-update/:id",
	DELETE_FAVOURITE: "/users/filters-delete/:id",
	UPDATE_DEFAULT_FAVOURITE: "/users/filters-update/:id/default",
};
//#endregion

//#region SERVICE INTERFACE
export interface IFavouriteFilterServices {
	getListOfFavourites(request: IFavouriteFilterRequestModel): any;
	getDetailFavourite(request: number): any;
	addFavourite(request: IFavouriteFilterModel): any;
	updateFavourite(request: IFavouriteFilterModel): any;
	deleteFavourite(request: number): any;
	updateDefaultFavourite(request: IFavouriteFilterModel): any;
}
//#endregion

//#region SERVICE IMPLEMENTED
export class FavouriteFilterServices extends ServicesWrapper
	implements IFavouriteFilterServices {
	mapperModel: FavouriteFilterModelMapper = new FavouriteFilterModelMapper();

	/** SERVICE: GET LIST FAVOURITES  */
	getListOfFavourites(request: IFavouriteFilterRequestModel) {
		return super.executeSelectingPost(
			request,
			favouriteFilterServicesUrl.LIST_FAVOURITES
		);
	}

	/** SERVICE: GET DETAIL FAVOURITE  */
	getDetailFavourite(favouriteId: any) {
		let url = favouriteFilterServicesUrl.DETAIL_FAVOURITE.replace(
			":id",
			favouriteId.Id.toString()
		);
		if (favouriteId.IsSystem) {
			url += `?IsSystem=${favouriteId.IsSystem}`;
		}
		return super.executeSelecting(undefined, url, false).then(response => {
			response.data = this.mapperModel.FromServerToClient(response.data)
			return Promise.resolve(response);
		});
	}

	/** SERVICE: ADD NEW FAVOURITE  */
	addFavourite(request: IFavouriteFilterModel) {
		let url = favouriteFilterServicesUrl.ADD_FAVOURITE;
		return super.executeSelectingPost(this.mapperModel.FromClientToServer(request), url);
	}

	/** SERVICE: UPDATE FAVOURITE  */
	updateFavourite(request: IFavouriteFilterModel) {
		let url = favouriteFilterServicesUrl.UPDATE_FAVOURITE.replace(
			":id",
			request.Id.toString()
		);
		return super.executeSelectingPost(this.mapperModel.FromClientToServer(request), url);
	}

	/** SERVICE: DELETE FAVOURITE  */
	deleteFavourite(id: number) {
		let url = favouriteFilterServicesUrl.DELETE_FAVOURITE.replace(
			":id",
			id.toString()
		);
		return super.executeDeleting(url);
	}

	/** SERVICE: UPDATE DEFAUTL  */
	updateDefaultFavourite(request: IFavouriteFilterModel) {
		let url = favouriteFilterServicesUrl.UPDATE_DEFAULT_FAVOURITE.replace(
			":id",
			request.Id.toString()
		);
		return super.executeSelectingPost(this.mapperModel.FromClientToServer(request), url);
	}
}

//#endregion

//#region MOCK SERVICE TO UNIT TEST
let mockFavouriteDataContext = new FavouriteFilterGroupModel({
	UserId: 0,
	Filters: [
		new FavouriteFilterModel({
			UserId: 0,
			Id: 1,
			Type: moduleConstant.Object,
			NameEN: "favourites 1 of Object "
		}),
		new FavouriteFilterModel({
			UserId: 0,
			Id: 2,
			Type: moduleConstant.Person,
			NameEN: "favourites 2 of Person "
		}),
		new FavouriteFilterModel({
			UserId: 0,
			Id: 3,
			Type: moduleConstant.Demand,
			NameEN: "favourites 3 of Demand "
		})
	]
});

export class MockFavouriteFilterServices extends ServicesWrapper
	implements IFavouriteFilterServices {
	/** SERVICE: GET LIST FAVOURITES  */
	getListOfFavourites(request: IFavouriteFilterRequestModel) {
		let response = mockFavouriteDataContext.Filters.filter(
			c => c.Type == request.Type
		);
		return new Promise((resolve, reject) => {
			resolve(
				new ApiResponse({
					isSuccess: true,
					data: [new FavouriteFilterGroupModel({ Filters: response })]
				})
			);
		});
	}

	/** SERVICE: GET DETAIL FAVOURITE  */
	getDetailFavourite(favouriteId: number) {
		return new Promise((resolve, reject) => {
			resolve(
				new ApiResponse({
					isSuccess: true,
					data: new FavouriteFilterModel({
						UserId: 0,
						Id: 1,
						NameEN: "filter name from fake serivce"
					})
				})
			);
		});
	}

	/** SERVICE: ADD NEW FAVOURITE  */
	addFavourite(request: IFavouriteFilterModel) {
		return new Promise((resolve, reject) => {
			request.Id = 1;
			mockFavouriteDataContext.Filters.push(request);
			resolve(
				new ApiResponse({
					isSuccess: true,
					data: request
				})
			);
		});
	}

	/** SERVICE: UPDATE FAVOURITE  */
	updateFavourite(request: IFavouriteFilterModel) {
		let favourite = mockFavouriteDataContext.Filters.find(
			c => c.Id == request.Id
		);
		favourite = request;
		return new Promise((resolve, reject) => {
			resolve(new ApiResponse({ isSuccess: true, data: favourite }));
		});
	}

	/** SERVICE: DELETE FAVOURITE  */
	deleteFavourite(id: number) {
		const favourite = mockFavouriteDataContext.Filters.find(c => c.Id == id);
		const index = mockFavouriteDataContext.Filters.indexOf(favourite);
		mockFavouriteDataContext.Filters.splice(index, 1);
		return new Promise((resolve, reject) => {
			resolve(new ApiResponse({ isSuccess: true }));
		});
	}

	/** SERVICE: UPDATE DEFAUTL  */
	updateDefaultFavourite(request: IFavouriteFilterModel) {
		alert('only mock service')
	}
}
//#endregion
